import { format, Locale, parseISO } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { Timestamp } from 'firebase/firestore';

/**
 * Format types available for dates
 */
export enum DateFormat {
  SHORT = 'dd/MM/yyyy',
  MEDIUM = 'd MMMM, yyyy',
  LONG = 'd MMMM, yyyy HH:mm',
  ISO = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"
}

/**
 * Formats a date string or Date object to the specified format
 * @param date - Date string or Date object to format
 * @param formatType - Format type from DateFormat enum
 * @param locale - Locale to use for formatting (default: en-US)
 * @returns Formatted date string
 */
export const formatDate = (
  date: string | Date | undefined | Timestamp,
  formatType: DateFormat = DateFormat.MEDIUM,
  locale: Locale = enUS
): string => {
  if (!date) return '';

  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : typeof date === 'object' && 'toDate' in date ? date.toDate() : date;
    return format(dateObj, formatType, { locale });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};
